<template>
    <div class="seller-order-send">
        <div class="common-header-wrap">
            <mt-header title="طلب الشحن" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <!-- header -->

        <div class="daddress_info" @click="goAddress">
            <div class="top-wrapper">
                <div v-if="daddress_info" class="selected-wrapper">
                    <div class="title-wrapper">
                        <i class="icon iconfont">&#xe6d3;</i>
                        <label class="title">{{daddress_info.seller_name}}</label>
                        <label class="title">{{daddress_info.daddress_telphone}}</label>
                        <label class="default" v-if="daddress_info.daddress_isdefault">إفتراضي</label>
                    </div>
                    <label class="desc address-text" style="-webkit-box-orient:vertical">{{daddress_info.area_info}}{{daddress_info.daddress_detail}}</label>
                </div>
                <div v-else class="unselected-wrapper">
                    <label class="desc">ليس لديك عنوان شحن حتى الآن ، انقر هنا لإضافته.</label>
                </div>
                <i class="indicator iconfont">&#xe650;</i>
            </div>
            <div class="line-wrapper"></div>
        </div>

        <div class="cart-subtotal">
            <div @click="popupExpress=true"><mt-cell class="menu-item" title="شركة التخطيط والتنفيذ" >{{express_name}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <div class="message" v-if="shipping_express_id!=0">
                <mt-field label="رقم الشحنة" type="text" v-model="shipping_code"></mt-field>
            </div>
        </div>
        <mt-button class="ds-button-large" type="primary" @click="submit">إرسال</mt-button>
        <mt-popup v-model="popupExpress" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="شركة التخطيط والتنفيذ" class="common-header">
                    <mt-button slot="left" icon="back" @click="popupExpress=false"></mt-button>
                    <mt-button slot="right" @click="setExpress(0,'بدون لوجستيات')">بدون لوجستيات</mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content" id="content">
                <div class="input-wrapper">
                    <input class="input" ref="input" type="text" v-model="keyword" placeholder="أدخل الكلمة المفتاحية" @keydown.enter="searchExpress()"/>
                </div>
                <div v-if="!keyword || !resultList">

                    <div class="select-wrapper" v-if="my_express && my_express.length">
                        <div class="title">بلدي اللوجستية</div>
                        <div class="content">
                            <div class="item" v-for="(item,index) in my_express" :key="index" @click="setExpress(item.express_id,item.express_name)"><span class="text">{{item.express_name}}</span></div>
                        </div>
                    </div>
                    <div class="select-wrapper" v-if="hot_express && hot_express.length">
                        <div class="title">الخدمات اللوجستية المشتركة</div>
                        <div class="content">
                            <div class="item" v-for="(item,index) in hot_express" :key="index" @click="setExpress(item.express_id,item.express_name)"><span class="text">{{item.express_name}}</span></div>
                        </div>
                    </div>
                    <div class="sort-list" id="ID">
                        <div v-for="(group,index) in all_express" :key="index">
                            <div class="letter" :id="group.letter">{{group.letter}}</div>
                            <div class="content">
                                <div class="item" v-for="(item,key) in group.list" :key="key" @click="setExpress(item.express_id,item.express_name)">{{item.express_name}}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <div class="sort-list">
                        <div class="content" v-if="resultList.length">
                            <div class="item" v-for="(item,key) in resultList" :key="key" @click="setExpress(item.express_id,item.express_name)">{{item.express_name}}</div>
                        </div>
                        <empty-record v-else></empty-record>
                    </div>
                </div>
                <div class="nav-list" v-if="!keyword || !resultList">
                    <div class="item" v-for="(item,index) in all_express" :key="index" @click="scrollTo(item.letter)">{{item.letter}}</div>
                </div>
            </div>
        </mt-popup>

    </div>
</template>

<script>
import { getExpressList, getExpressInfo } from '../../../api/sellerExpress'
import { sendOrder } from '../../../api/sellerOrder'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import EmptyRecord from '../../EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  name: 'SellerOrderSend',
  data () {
    return {
      keyword: '',
      order_id: this.$route.query.order_id,
      daddress_info: false,
      shipping_code: '',
      shipping_express_id: 0,
      express_name: 'بدون لوجستيات',
      popupExpress: false,
      all_express: [],
      hot_express: [],
      my_express: [],
      resultList: false
    }
  },

  mounted () {
  },
  computed: {

  },
  created: function () {
    let _this = this
    getExpressInfo(this.order_id).then(res => {
      this.daddress_info = res.result.daddress_info
    }).catch(function (error) {
      Toast(error.message)
      if (error.code == '12002') {
        _this.goAddress()
      }
    })
    getExpressList(this.order_id).then(res => {
      this.all_express = res.result.all_express
      this.my_express = res.result.my_express
      this.hot_express = res.result.hot_express
    }).catch(function (error) {
      Toast(error.message)
    })
  },

  methods: {
    setExpress (id, name) {
      this.shipping_express_id = id
      this.express_name = name
      this.popupExpress = false
    },
    scrollTo (str) {
      // if (str != '#') {
      document.getElementById(str).scrollIntoView()
      // } else {
      //     document.getElementById('content').scrollIntoView()
      // }
    },
    searchExpress () {
      if (!this.keyword) {
        this.resultList = false
      } else {
        var resultList = []
        for (var i in this.all_express) {
          for (var j in this.all_express[i].list) {
            var str = this.all_express[i].list[j].express_name
            if (str.search(this.keyword) != -1) {
              resultList.push(this.all_express[i].list[j])
            }
          }
        }
        this.resultList = resultList
      }
    },
    goAddress () {
      if (this.daddress_info) {
        this.$router.push({ name: 'SellerAddressList' })
      } else {
        this.$router.push({
          name: 'SellerAddressForm',
          query: {
            action: 'add',
            isFromCheckout: true,
            goBackLevel: -1
          }
        })
      }
    },
    submit () {
      if (this.shipping_express_id == 0) {
        this.shipping_express_id = ''
      }
      if (!this.daddress_info) {
        Toast('الرجاء إضافة عنوان الشحن أولا')
        return
      }
      if (this.shipping_express_id != '' && this.shipping_code == '') {
        Toast('يرجى ملء رقم الطلب اللوجستي أولاً')
        return
      }
      sendOrder(this.order_id, this.shipping_express_id, this.shipping_code, this.daddress_info.daddress_id).then(res => {
        Toast(res.message)
        this.$router.go(-1)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
    .daddress_info {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        height: 5rem;
        .top-wrapper {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            background-color: #fff;
        }
        .selected-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
        }
        .title-wrapper {
            height: 1rem;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }
        .icon {
            width: 0.8rem;
            height: 0.8rem;
            margin-left: 0.5rem;
        }
        .title {
            font-size: 0.8rem;
            color: #333;
            margin-left: 0.5rem;
        }
        .default {
            width: 1.4rem;
            margin-left: 0.5rem;
            margin-right: 0.5rem;
            border: 1px solid #e93b3d;
            color: $primaryColor;
            font-size: 0.5rem;
            text-align: center;
            border-radius: 0.1rem;
        }
        .desc {
            color: #7C7F88;
            font-size: 0.7rem;
        }
        .address-text {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
            margin-left: 1.8rem;
        }
        .unselected-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .indicator {
            width: 0.35rem;
            height: 0.6rem;
            margin-left: 0.5rem;
            margin-right: 0.5rem;
        }
        .line-wrapper {
            background:#eee;
            // position: relative;
            left:0;
            right:0;
            bottom:0;
            width: 100%;
            height: 0.1rem;
        }
    }

    .nav-list{position: fixed;right:0;top:5.5rem;font-size: .6rem;text-align: center;bottom:4rem;
        .item{height: 4.347826%;width:1rem;}
    }
    .input-wrapper{padding:1rem;position:relative;font-size: .7rem;text-align: center;
        .placeholder{position: absolute;top:1rem;left:0;width:100%;color:#999;line-height: 1.5rem;}
        .input{width:100%;height: 1.5rem;line-height: 1.5rem;border-radius: 1.5rem;border:1px solid #e1e1e1;text-align: center;}
    }
    .select-wrapper{
        .title{padding:1rem;font-size:.7rem;color:#666;padding-top:0}
        .content{overflow:hidden;padding:0 .5rem;
            .item{float:left;width:25%;padding:0 .5rem;box-sizing:border-box;font-size:.7rem;height:1.5rem;line-height:1.5rem;margin-bottom:1rem;
                .text{border:1px solid #e1e1e1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;border-radius:.2rem;text-align:center;background:#fff;
                }
            }
        }
    }
    .sort-list{padding:0 1rem;font-size:.7rem;
        .letter{}
        .content{padding-bottom:1rem;
            .item{line-height:2rem;border-bottom:1px solid #e1e1e1}
        }
    }
</style>
